<template>
  <b-form
    @submit.prevent="$emit('submit', model)"
    @keydown.enter="$emit('submit', model)"
  >
    <b-row>
      <b-col sm="12">
        <b-form-group>
          <label>
            Fecha entre
          </label>
          <b-row no-gutters>
            <b-col cols="6">
              <b-form-datepicker
                :value="model.date_min"
                class="margin-right-datepicker"
                :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                size="sm"
                reset-button
                :hide-header="true"
                placeholder="Desde"
                :label-help="null"
                :max="model.date_max"
                @input="update('date_min', $event)"
              />
            </b-col>
            <b-col cols="6">
              <b-form-datepicker
                :value="model.date_max"
                class="margin-left-datepicker"
                :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                size="sm"
                reset-button
                :hide-header="true"
                placeholder="Hasta"
                :label-help="null"
                :min="model.date_min"
                @input="update('date_max', $event)"
                start-weekday="1"
              />
            </b-col>
          </b-row>
        </b-form-group>
      </b-col>
      <b-col sm="12">
        <b-form-group
          label="Nº Pedido"
          label-for="delivery-notes-order"
        >
          <BaseSelect
            id="delivery-notes-order"
            label="number"
            :resource="$data.$constants.RESOURCES.RESOURCE_ORDERS"
            :value="model.order"
            @input="update('order', $event)"
          />
        </b-form-group>
      </b-col>
      <b-col sm="12">
        <b-form-group
          label="Proveedor"
          label-for="delivery-notes-provider"
        >
          <BaseSelect
            id="delivery-notes-provider"
            :resource="$data.$constants.RESOURCES.RESOURCE_PROVIDERS"
            :value="model.provider"
            @input="update('provider', $event)"
          />
        </b-form-group>
      </b-col>
      <b-col sm="12">
        <b-form-group
          label="Nº Factura"
          label-for="delivery-notes-purchase-invoice"
        >
          <BaseSelect
            id="delivery-notes-purchase-invoice"
            :value="model.purchase_invoice"
            resource="purchase-invoices"
            label="number"
            @input="update('purchase_invoice', $event)"
          />
        </b-form-group>
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
import FormMixin from '@/mixins/formMixin'
import BaseSelect from '@/components/ui/select/BaseSelect.vue'

export default {
  name: 'DeliveryNotesListFiltersForm',
  components: {
    BaseSelect,
  },
  mixins: [FormMixin],
}
</script>

<style scoped>
.margin-left-datepicker {
  margin-left: 5px;
}
.margin-right-datepicker {
  margin-right: 5px;
}
</style>
